import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon     from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg     from "../../../asset/images/power&surveillance/liferaft/hero-bg.webp";
import HeroMobileImg from "../../../asset/images/power&surveillance/liferaft/hero-bg-mobile.webp";
import LiferaftImg   from "../../../asset/images/power&surveillance/liferaft/liferaft.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .lf { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .lf-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .lf-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .lf-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .lf-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .lf-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .lf-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .lf-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .lf-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .lf-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .lf-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .lf-subnav-link.lf-active { font-weight: 500; }
  .lf-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .lf-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .lf-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }

  /* DROPDOWN — position:absolute under the nav item */
  .lf-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .lf-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .lf-subnav-dropdown-item:last-child { border-bottom: none; }
  .lf-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .lf-subnav-dropdown-item.lf-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .lf-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .lf-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .lf-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .lf-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .lf-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .lf-sidebar-overlay.open { display: block; }
  .lf-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .lf-sidebar.open { transform: translateX(0); }
  .lf-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .lf-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .lf-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lf-sidebar-nav { flex: 1; overflow-y: auto; }
  .lf-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .lf-sidebar-row:hover { background: #fafafa; }
  .lf-sidebar-row.active { color: #000000; font-weight: 400; }
  .lf-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .lf-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .lf-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .lf-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .lf-sidebar-subitem:last-child { }
  .lf-sidebar-subitem:hover { background: #fafafa; }
  .lf-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .lf-breadcrumb { padding: 60px 0 0 0; }
  .lf-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .lf-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .lf-bc-item:hover { color: #EB2019; }
  .lf-bc-item.active { color: #202020; }
  .lf-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .lf-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .lf-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .lf-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .lf-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .lf-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* SCROLL ANCHOR */
  .lf-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .lf-section-content { padding: 80px 0 0 0; }
  .lf-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .lf-content-left { flex: 0 0 766px; }
  .lf-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lf-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lf-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .lf-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .lf-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .lf-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .lf-para + .lf-para { margin-top: 14px; }
  .lf-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .lf-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .lf-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .lf-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .lf-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .lf-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .lf-hero-bg        { display: block; }
    .lf-subnav         { top: 70px; }
    .lf-anchor         { scroll-margin-top: 110px; }
    .lf-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .lf-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .lf-hero              { height: 300px; }
    .lf-hero-content      { padding: 0 32px; }
    .lf-hero-title        { font-size: 26px; }
    .lf-breadcrumb        { padding: 28px 0 0 0; }
    .lf-breadcrumb-inner  { padding: 0 24px; }
    .lf-inner             { padding: 0 24px; }
    .lf-divider           { padding: 0px 32px 0px 32px; }
    .lf-divider:last-child { display: none; }
    .lf-divider-slim      { padding: 20px 24px 0 24px; }
    .lf-section-content   { padding: 40px 0 0 0; }
    .lf-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .lf-content-left      { flex: none; width: 100%; }
    .lf-features-tag      { margin: 24px 0 24px 0; }
    .lf-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .lf-img-col           { min-height: 260px; width: 100%; }
    .lf-img-wrap          { max-height: 450px; }
    .lf-red-title         { font-size: 24px; margin-bottom: 10px; }
    .lf-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .lf-para              { font-size: 14px; }
    .lf-para + .lf-para   { margin-top: 10px; }
    .lf-features-list li  { font-size: 14px; }
    .lf-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .lf-subnav           { display: none; }
    .lf-mobile-bar       { display: flex; height: 46px; }
    .lf-sidebar-header   { height: 46px; }
    .lf-anchor           { scroll-margin-top: 80px; }
    .lf-hero-bg          { display: none; }
    .lf-hero-bg-mobile   { display: block; }
    .lf-hero             { height: 370px; }
    .lf-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .lf-hero-title       { font-size: 22px; }
    .lf-breadcrumb       { padding: 22px 0 0 0; }
    .lf-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .lf-bc-item          { font-size: 14px; }
    .lf-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .lf-inner            { padding: 0 16px; }
    .lf-divider          { padding: 0px 16px; }
    .lf-divider-slim     { padding: 30px 16px 0 16px; }
    .lf-section-content  { padding: 60px 0 0 0; }
    .lf-section-content:last-child { padding: 60px 0 0px 0; }
    .lf-divider:last-child { display: none; }
    .lf-content-grid:last-child { margin-bottom: 60px !important; }
    .lf-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .lf-img-wrap         { max-height: 260px; }
    .lf-red-title        { font-size: 20px; margin-bottom: 10px; }
    .lf-subtitle         { font-size: 16px; margin-bottom: 10px; }
    .lf-para             { font-size: 14px; }
    .lf-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", href: "/power-surveillance/liferaft-modular#lm-product-1" },
      { label: "Liferaft Modular 25kVA To 600kVA", href: "/power-surveillance/liferaft-modular#lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft", active: true },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/business/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",    href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)",  href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "lf-product-1",
    title:    "LIFERAFT (10 KVA – 500 KVA)",
    subtitle: "Next Generation Modular UPS 1:1/3:1/3:3 Phase PF 0.8",
    paras: [
      '"LIFERAFT" is a true online modular Uninterrupted Power Supply system  based on True Online Battery Topology, upgraded from 10kVA-100kVA  and in parallel upto 500kVA. LIFERAFT has maximum safety without transferring the load to bypass source. LIFERAFT is a next generation system specially designed with unmatched reliability, pure power  quality and very high electrical efficiency for critical applications',
    ],
    features: [
      "True Modularity",
      "True Rightsizing",
      "True Green Power",
      "True On-line",
      "Small footprint and lightweight",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: true,
    imgSrc: LiferaftImg,
  },
];

/* ── SubnavItem — hover with position:absolute dropdown ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="lf-subnav-item">
        <a
          href={item.href || "#"}
          className={`lf-subnav-link${item.active ? " lf-active" : ""}`}
        >
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="lf-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a
        href={item.href || "#"}
        className={`lf-subnav-link${item.active ? " lf-active" : ""}`}
      >
        {item.label}
        <span className={`lf-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="lf-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`lf-subnav-dropdown-item${child.active ? " lf-dd-active" : ""}`}
              onClick={() => setOpen(false)}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`lf-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`lf-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`lf-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="lf-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`lf-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={onClose}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function Liferaft() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="lf">
        <section className="lf-hero">
          <img className="lf-hero-bg" src={HeroBgImg} alt="" />
          <img className="lf-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="lf-hero-content">
            <h1 className="lf-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      {/* SUBNAV outside .lf */}
      <nav className="lf-subnav" aria-label="Product categories">
        <div className="lf-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      {/* MOBILE BAR outside .lf */}
      <div className="lf-mobile-bar">
        <span className="lf-mobile-bar-title">Liferaft</span>
        <button className="lf-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      <div
        className={`lf-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`lf-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="lf-sidebar-header">
          <span className="lf-sidebar-header-title">Liferaft</span>
          <button className="lf-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="lf-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      {/* REST OF PAGE */}
      <div className="lf">
        <nav className="lf-breadcrumb" aria-label="Breadcrumb">
          <div className="lf-breadcrumb-inner">
            <a href="/" className="lf-bc-item">Home</a>
            <span className="lf-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="lf-bc-item">Business</a>
            <span className="lf-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="lf-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="lf-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="lf-anchor" />
            <section className="lf-section-content">
              <div className="lf-inner">
                <div
                  className="lf-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="lf-content-left">
                    <h2 className="lf-red-title">{product.title}</h2>
                    <h3 className="lf-subtitle">{product.subtitle}</h3>
                    {product.paras.map((p, i) => (
                      <p key={i} className="lf-para">{p}</p>
                    ))}
                    <div className="lf-features-tag">
                      <div className="lf-features-tag-bar" />
                      <span className="lf-features-tag-text">Features</span>
                    </div>
                    <ul className="lf-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="lf-img-col">
                    <div className="lf-img-wrap">
                      {product.imgSrc &&
                        <img className="lf-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="lf-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}